import { render, staticRenderFns } from "./PayrollConceptList.vue?vue&type=template&id=4595735c"
import script from "./PayrollConceptList.vue?vue&type=script&lang=js"
export * from "./PayrollConceptList.vue?vue&type=script&lang=js"
import style0 from "./PayrollConceptList.vue?vue&type=style&index=0&id=4595735c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports